import { ToggleButtonGroupCSSStyleImpl } from "./togglebuttongroupcss";

export class FlashMessageToggleButtonGroupCSSStyleImpl extends ToggleButtonGroupCSSStyleImpl
{ 
  getTabHeaderCSSStyle(): object 
  {
      return {
          // height: "40px",
          width: "auto",
          textAlign: "center",
          boxSizing: "border-box",
          backgroundColor: "#EAEDF0",
          borderRadius: "10px",
          // display: "flex",
          border: "1px solid #EAEDF0",
          position: "relative",
          // flexDirection: "row",
          // flexFlow: "row wrap",
      };
  }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/togglebuttongroup/flashmessagetogglebuttongroupcss.tsx